export const adExtensionsLegacyStrings = {
  // Extension Titles
  AdExtensions_Title_Action: _TL_('Action extensions'),
  AdExtensions_Title_App: _TL_('App extensions'),
  AdExtensions_Title_Call: _TL_('Call extensions'),
  AdExtensions_Title_Callout: _TL_('Callout extensions'),
  AdExtensions_Title_FilterLink: _TL_('Filter link extensions'),
  AdExtensions_Title_Flyer: _TL_('Flyer extensions'),
  AdExtensions_Title_Location: _TL_('Location extensions'),
  AdExtensions_Title_Price: _TL_('Price extensions'),
  AdExtensions_Title_Promotion: _TL_('Promotion extensions'),
  AdExtensions_Title_Review: _TL_('Review extensions'),
  AdExtensions_Title_SiteLink: _TL_('Sitelink extensions'),
  AdExtensions_Title_StructuredSnippet: _TL_('Structured snippet extensions'),

  // Call Extension Strings
  AdExtensions_Call_Singular: _TL_('1 call extension set'),
  AdExtensions_Call_Plural: _TL_('{{number}} call exensions set'),
  AdExtensions_Call_None: _TL_('No call extensions set'),
  AdExtensions_Call_Description: _TL_('Show your business’s phone number in your ads to let customers know they can click to call.'),
  AdExtensions_Call_Description_AriaLabel: _TL_('Call extensions description'),

  // Callout Extension Strings
  AdExtensions_Callout_Singular: _TL_('1 callout extension set'),
  AdExtensions_Callout_Plural: _TL_('{{number}} callout extensions set'),
  AdExtensions_Callout_None: _TL_('No callout extensions set'),
  AdExtensions_Callout_Description: _TL_("Show extra details about your website's products or offers in your ads."),
  AdExtensions_Callout_Description_AriaLabel: _TL_('Callout extensions description'),

  // Location Extension Strings
  AdExtensions_Location_Singular: _TL_('1 location extension set'),
  AdExtensions_Location_Plural: _TL_('{{number}} location extensions set'),
  AdExtensions_Location_None: _TL_('No location extensions set'),
  AdExtensions_Location_Description: _TL_('Show the address and phone number of your closest business location in your ads.'),
  AdExtensions_Location_Description_AriaLabel: _TL_('Location extensions description'),

  // Review Extension Strings
  AdExtensions_Review_Singular: _TL_('1 review extension set'),
  AdExtensions_Review_Plural: _TL_('{{number}} review extensions set'),
  AdExtensions_Review_None: _TL_('No review extensions set'),
  AdExtensions_Review_Description: _TL_('Show a positive review from a third-party source in your ads.'),
  AdExtensions_Review_Description_AriaLabel: _TL_('Review extensions description'),

  // Sitelink Extension Strings
  AdExtensions_SiteLink_Singular: _TL_('1 sitelink extension set'),
  AdExtensions_SiteLink_Plural: _TL_('{{number}} sitelink extensions set'),
  AdExtensions_SiteLink_None: _TL_('No sitelink extensions set'),
  AdExtensions_SiteLink_Description: _TL_('Show additional sitelinks in your ads that take customers to specific pages of your website'),
  AdExtensions_SiteLink_Description_AriaLabel: _TL_('Sitelink extensions description'),

  // Structured Snippet Extension Strings
  AdExtensions_StructuredSnippet_Singular: _TL_('1 structured snippet extension set'),
  AdExtensions_StructuredSnippet_Plural: _TL_('{{number}} structured snippet extensions set'),
  AdExtensions_StructuredSnippet_None: _TL_('No structured snippet extensions set'),
  AdExtensions_StructuredSnippet_Description: _TL_('Highlight specific aspects of your products and services using structured snippets.'),
  AdExtensions_StructuredSnippet_Description_AriaLabel: _TL_('Structured snippet extensions description'),

  // Price Extension Strings
  AdExtensions_Price_Singular: _TL_('1 price extension set'),
  AdExtensions_Price_Plural: _TL_('{{number}} price extensions set'),
  AdExtensions_Price_None: _TL_('No price extensions set'),
  AdExtensions_Price_Description: _TL_('Provide valuable price information to your prospective customers before they click on your ad.'),
  AdExtensions_Price_Description_AriaLabel: _TL_('Price extensions description'),

  // Promotion Extension Strings
  AdExtensions_Promotion_Singular: _TL_('1 promotion extension set'),
  AdExtensions_Promotion_Plural: _TL_('{{number}} promotion extensions set'),
  AdExtensions_Promotion_None: _TL_('No promotion extensions set'),
  AdExtensions_Promotion_Description: _TL_('Show deals for holidays and other special occasions in your ads.'),
  AdExtensions_Promotion_Description_AriaLabel: _TL_('Promotion extensions description'),

  // Filter Link Extension Strings
  AdExtensions_FilterLink_Singular: _TL_('1 filter link extension set'),
  AdExtensions_FilterLink_Plural: _TL_('{{number}} filter link extensions set'),
  AdExtensions_FilterLink_None: _TL_('No filter link extensions set'),
  AdExtensions_FilterLink_Description: _TL_('Show links to specific products and services using filter links.'),
  AdExtensions_FilterLink_Description_AriaLabel: _TL_('Filter link extensions description'),

  // Flyer Extension Strings
  AdExtensions_Flyer_Singular: _TL_('1 flyer extension set'),
  AdExtensions_Flyer_Plural: _TL_('{{number}} flyer extensions set'),
  AdExtensions_Flyer_None: _TL_('No flyer extensions set'),
  AdExtensions_Flyer_Description: _TL_('Showcase flyers of your chosen products and promotions, providing potential customers with more information before they buy.'),
  AdExtensions_Flyer_Description_AriaLabel: _TL_('Flyer extensions description'),

  // Action Extension Strings
  AdExtensions_Action_Singular: _TL_('1 action extension set'),
  AdExtensions_Action_Plural: _TL_('{{number}} action extensions set'),
  AdExtensions_Action_None: _TL_('No action extensions set'),
  AdExtensions_Action_Description: _TL_('Show an action button in your ads.'),
  AdExtensions_Action_Description_AriaLabel: _TL_('Action extensions description'),

  AdExtensions_StartDateAndEndDate: _TL_('Displayed start date - Displayed end date'),
  AdExtensions_Occasions: _TL_('Occasion'),
  AdExtensions_Item: _TL_('Item'),
  AdExtensions_Promotion_Type: _TL_('Promotion type'),
  AdExtensions_Promotion_Details: _TL_('Promotion details'),
  AdExtensions_StartDateAndEndDate_Alert: _TL_('Please ensure that the <b>Displayed start date – Displayed end date</b> matches your promotion extension’s <b>Start date</b> and <b>End date</b> below <b>Selected days and hours</b>.'),
  AdExtensions_OCCASION_HINT: _TL_('After choosing an occasion from the list, be sure to set your promotion extension’s <b>Start date</b> and <b>End date</b> below <b>Selected days and hours</b>. Otherwise, the promotion extension will serve every year during the occasion’s predefined date range. Please note that your promotion extension will show continuously if you set the occasion to <b>None</b> and don’t enter the <b>Start date</b> and <b>End date</b>. <a class="HelpTopic" query="60046" href="#">Learn more</a>'),
  AdExtensions_OnOrdersOver: _TL_('On orders over'),
  AdExtensions_PromotionCode: _TL_('Promotion code'),
  AdExtensions_Promotion_MonetaryDiscount: _TL_('Monetary discount'),
  AdExtensions_Promotion_PercentDiscount: _TL_('Percent discount'),
  AdExtensions_Promotion_UptoMonetaryDiscount: _TL_('Up to monetary discount'),
  AdExtensions_Promotion_UptoPercentDiscount: _TL_('Up to percent discount'),

  // Promotion Extension Details
  None: _TL_('None'),
  BackToSchool: _TL_('Back to School'),
  BlackFriday: _TL_('Black Friday'),
  BoxingDay: _TL_('Boxing Day'),
  Carnival: _TL_('Carnival'),
  ChineseNewYear: _TL_('Chinese New Year'),
  Christmas: _TL_('Christmas'),
  CyberMonday: _TL_('Cyber Monday'),
  Diwali: _TL_('Diwali'),
  Easter: _TL_('Easter'),
  EidAlAdha: _TL_('Eid al-Adha'),
  EidAlFitr: _TL_('Eid al-Fitr'),
  EndOfSeason: _TL_('End of Season'),
  Epiphany: _TL_('Epiphany'),
  FallSale: _TL_('Fall Sale'),
  FathersDay: _TL_("Father's Day"),
  Halloween: _TL_('Halloween'),
  Hanukkah: _TL_('Hanukkah'),
  Holi: _TL_('Holi'),
  IndependenceDay: _TL_('Independence Day'),
  LaborDay: _TL_('Labor Day'),
  MothersDay: _TL_("Mother's Day"),
  NationalDay: _TL_('National Day'),
  Navratri: _TL_('Navratri'),
  NewYears: _TL_("New Year's"),
  ParentsDay: _TL_("Parent's Day"),
  Passover: _TL_('Passover'),
  Ramadan: _TL_('Ramadan'),
  RoshHashanah: _TL_('Rosh Hashanah'),
  SinglesDay: _TL_("Single's Day"),
  Songkran: _TL_('Songkran'),
  SpringSale: _TL_('Spring Sale'),
  StNicholasDay: _TL_('St. Nicholas Day'),
  SummerSale: _TL_('Summer Sale'),
  ValentinesDay: _TL_("Valentine's Day"),
  WinterSale: _TL_('Winter Sale'),
  WomensDay: _TL_("Women's Day"),
  YearEndGift: _TL_('Year-End Gift'),

  // Currency strings
  Currency_ALL: _TL_('ALL'),
  Currency_AED: _TL_('AED'),
  Currency_ARS: _TL_('ARS'),
  Currency_AMD: _TL_('AMD'),
  Currency_AUD: _TL_('AUD'),
  Currency_AZN: _TL_('AZN'),
  Currency_BHD: _TL_('BHD'),
  Currency_BDT: _TL_('BDT'),
  Currency_BZD: _TL_('BZD'),
  Currency_BOB: _TL_('BOB'),
  Currency_BWP: _TL_('BWP'),
  Currency_BRL: _TL_('BRL'),
  Currency_GBP: _TL_('GBP'),
  Currency_BND: _TL_('BND'),
  Currency_BGN: _TL_('BGN'),
  Currency_CAD: _TL_('CAD'),
  Currency_CHF: _TL_('CHF'),
  Currency_CLP: _TL_('CLP'),
  Currency_CNY: _TL_('CNY'),
  Currency_COP: _TL_('COP'),
  Currency_CRC: _TL_('CRC'),
  Currency_CZK: _TL_('CZK'),
  Currency_DKK: _TL_('DKK'),
  Currency_DOP: _TL_('DOP'),
  Currency_DZD: _TL_('DZD'),
  Currency_XCD: _TL_('XCD'),
  Currency_EGP: _TL_('EGP'),
  Currency_ETB: _TL_('ETB'),
  Currency_EUR: _TL_('EUR'),
  Currency_FJD: _TL_('FJD'),
  Currency_GEL: _TL_('GEL'),
  Currency_GHS: _TL_('GHS'),
  Currency_GTQ: _TL_('GTQ'),
  Currency_HNL: _TL_('HNL'),
  Currency_HKD: _TL_('HKD'),
  Currency_HRK: _TL_('HRK'),
  Currency_HUF: _TL_('HUF'),
  Currency_ISK: _TL_('ISK'),
  Currency_INR: _TL_('INR'),
  Currency_IDR: _TL_('IDR'),
  Currency_IQD: _TL_('IQD'),
  Currency_ILS: _TL_('ILS'),
  Currency_JMD: _TL_('JMD'),
  Currency_JPY: _TL_('JPY'),
  Currency_JOD: _TL_('JOD'),
  Currency_KZT: _TL_('KZT'),
  Currency_KES: _TL_('KES'),
  Currency_KWD: _TL_('KWD'),
  Currency_KGS: _TL_('KGS'),
  Currency_KRW: _TL_('KRW'),
  Currency_LBP: _TL_('LBP'),
  Currency_LKR: _TL_('LKR'),
  Currency_LYD: _TL_('LYD'),
  Currency_MOP: _TL_('MOP'),
  Currency_MKD: _TL_('MKD'),
  Currency_MWK: _TL_('MWK'),
  Currency_MYR: _TL_('MYR'),
  Currency_MVR: _TL_('MVR'),
  Currency_MUR: _TL_('MUR'),
  Currency_MXN: _TL_('MXN'),
  Currency_MNT: _TL_('MNT'),
  Currency_MAD: _TL_('MAD'),
  Currency_NZD: _TL_('NZD'),
  Currency_NIO: _TL_('NIO'),
  Currency_NGN: _TL_('NGN'),
  Currency_NOK: _TL_('NOK'),
  Currency_OMR: _TL_('OMR'),
  Currency_PKR: _TL_('PKR'),
  Currency_PAB: _TL_('PAB'),
  Currency_PYG: _TL_('PYG'),
  Currency_PEN: _TL_('PEN'),
  Currency_PHP: _TL_('PHP'),
  Currency_PLN: _TL_('PLN'),
  Currency_QAR: _TL_('QAR'),
  Currency_RON: _TL_('RON'),
  Currency_RSD: _TL_('RSD'),
  Currency_RUB: _TL_('RUB'),
  Currency_RWF: _TL_('RWF'),
  Currency_SAR: _TL_('SAR'),
  Currency_SEK: _TL_('SEK'),
  Currency_SGD: _TL_('SGD'),
  Currency_TZS: _TL_('TZS'),
  Currency_THB: _TL_('THB'),
  Currency_TOP: _TL_('TOP'),
  Currency_TTD: _TL_('TTD'),
  Currency_TND: _TL_('TND'),
  Currency_TRY: _TL_('TRY'),
  Currency_TWD: _TL_('TWD'),
  Currency_UGX: _TL_('UGX'),
  Currency_UAH: _TL_('UAH'),
  Currency_UYU: _TL_('UYU'),
  Currency_USD: _TL_('USD'),
  Currency_UZS: _TL_('UZS'),
  Currency_VEF: _TL_('VEF'),
  Currency_VES: _TL_('VES'),
  Currency_VND: _TL_('VND'),
  Currency_XAF: _TL_('XAF'),
  Currency_XOF: _TL_('XOF'),
  Currency_YER: _TL_('YER'),
  Currency_ZAR: _TL_('ZAR'),
  Currency_ZMW: _TL_('ZMW'),
};
